import React from "react";
import tw from "twin.macro"; //eslint-disable-line
import { css } from "styled-components/macro"; //eslint-disable-line
import AnimationRevealPage from "helpers/AnimationRevealPage.js";

import Hero from "components/hero/FullWidthWithImage.js";
import Features from "components/features/DashedBorderSixFeatures";
import MainFeature from "components/features/TwoColSingleFeatureWithStats2.js";
import MainFeature2 from "components/features/TwoColWithTwoFeaturesAndButtons.js";
import Slider from "components/cards/ThreeColSlider.js";
import FAQ from "components/faqs/SimpleWithSideImage.js";
import ContactUsForm from "components/forms/TwoColContactUsWithIllustrationFullForm.js";
import Footer from "components/footers/MiniCenteredFooter.js";
import customerSupportIllustrationSrc from "images/customer-support-illustration.svg";
import ScrollButton from "components/misc/ScrollButton";
export default () => (
  <AnimationRevealPage >
    <ScrollButton/>
    <Hero />
    <MainFeature />
    <Features />
    <MainFeature2 />
    <Slider/>
    <FAQ
      imageSrc={customerSupportIllustrationSrc}
      imageContain={true}
      imageShadow={false}
      subheading="FAQs"
      heading={
        <>
          Tem algumas <span tw="text-primary-500">Questões ?</span>
        </>
      }
    />
    <ContactUsForm id='#contactos' />
    <Footer />
  </AnimationRevealPage>
);
